var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompany3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02512 6.06719L0.0576172 11.0347L5.02512 16.0022L9.99262 11.0347L5.02512 6.06719Z",
    fill: "#64748B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 11.0325L5.03191 6.06313C6.34881 7.38051 7.08862 9.167 7.08862 11.0297C7.08862 12.8925 6.34881 14.679 5.03191 15.9963L0.0625 20.9602L5.03191 25.9295L10.0013 20.9602L14.9707 15.9963L10.0013 11.0325Z",
    fill: "#CBD5E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0847 25.9403L32.0521 20.9728L27.0847 16.0053L22.1172 20.9728L27.0847 25.9403Z",
    fill: "#64748B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1181 20.9713L27.0875 25.9351C25.7706 24.6178 25.0308 22.8313 25.0308 20.9685C25.0308 19.1058 25.7706 17.3193 27.0875 16.0019L32.057 11.0325L27.0875 6.06313L22.1181 11.0325L17.1543 16.0019L22.1181 20.9713Z",
    fill: "#CBD5E1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12402 27.0325L11.0915 32L16.059 27.0325L11.0915 22.065L6.12402 27.0325Z",
    fill: "#64748B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0924 22.0575L6.12305 27.0269C7.44042 25.71 9.22687 24.9702 11.0896 24.9702C12.9523 24.9702 14.7388 25.71 16.0562 27.0269L21.0201 31.9964L25.9895 27.0269L21.0201 22.0575L16.0562 17.0937L11.0924 22.0575Z",
    fill: "#CBD5E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9985 4.96754L21.031 0L16.0635 4.9675L21.031 9.93504L25.9985 4.96754Z",
    fill: "#64748B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0312 9.94053L25.995 4.97115C24.6776 6.28805 22.8911 7.02786 21.0284 7.02786C19.1657 7.02786 17.3792 6.28805 16.0618 4.97115L11.0924 0.0017395L6.12305 4.97115L11.0924 9.94053L16.0618 14.9099L21.0312 9.94053Z",
    fill: "#CBD5E1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany3);
export default __webpack_public_path__ + "static/media/company3.342d738b8d65796f1c7d96f84c4ea047.svg";
export { ForwardRef as ReactComponent };